import React from 'react';
import { Utensils, Home, Cake } from 'lucide-react';
export function SocialProofSection() {
  const scenarios = [{
    icon: <Utensils className="w-8 h-8 text-gold" data-id="element-456" />,
    title: 'En un restaurante',
    desc: 'Aprendé a leer el menú estratégicamente. Sabrás qué pedir para disfrutar sin que tu vientre se inflame a los 20 minutos.'
  }, {
    icon: <Home className="w-8 h-8 text-gold" data-id="element-457" />,
    title: 'Casa de tu suegra',
    desc: 'Técnicas sutiles para comer lo que te sirven sin romper el plan, usando el orden de los alimentos a tu favor.'
  }, {
    icon: <Cake className="w-8 h-8 text-gold" data-id="element-458" />,
    title: 'Cumpleaños o eventos',
    desc: 'El protocolo exacto para antes y después del evento que "amortigua" el impacto del azúcar y el alcohol en tu intestino.'
  }];
  return <section className="py-10 bg-cream" data-id="element-459">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-460">
        <div className="max-w-6xl mx-auto" data-id="element-461">
          <div className="text-center mb-8" data-id="element-462">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-4" data-id="element-463">
              Casos de la vida real
            </h2>
            <p className="text-lg text-sage/80 max-w-2xl mx-auto" data-id="element-464">
              Tu vida no se detiene porque estés cuidando tu salud. El protocolo
              se adapta a vos, no al revés.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-465">
            {scenarios.map((scenario, idx) => <div key={idx} className="bg-white rounded-2xl p-8 shadow-md border border-sage/5 hover:shadow-xl transition-shadow duration-300" data-id="element-466">
                <div className="bg-cream w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-467">
                  {scenario.icon}
                </div>
                <h3 className="text-xl font-serif font-bold text-sage mb-4" data-id="element-468">
                  {scenario.title}
                </h3>
                <p className="text-sage/70 leading-relaxed" data-id="element-469">{scenario.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}